const fetch = (url, options) => {
  options = {
    ...options,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      ...options.headers,
    },
  };
  return window.fetch(url, options);
};

export const cartChangeRequest = async (id, quantity) => {
  const body = JSON.stringify({
    id,
    quantity,
  });

  const url = `${window.Shopify.routes.root}cart/change.js`;

  const response = await fetch(url, {
    method: "POST",
    body,
  });

  const data = await response.json();

  if (!response.ok) {
    let errorMessage = data.errors ?? data.description;
    throw new Error(errorMessage);
  }

  return data;
};

export const deleteLineItemRequest = async (id) => {
  return cartChangeRequest(id, 0);
};
